import { SVGProps } from 'react';

export default function MenuArrows(props: Partial<SVGProps<any>>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="19" viewBox="0 0 15 19" fill="none" preserveAspectRatio='none' {...props}>
      <path d="M0.922852 5.84615L7.49977 0L14.0767 5.84615H0.922852Z" fill="#FF00FE" />
      <path d="M14.0767 13.1538L7.49974 19L0.922815 13.1538L14.0767 13.1538Z" fill="#FF00FE" />
    </svg>
  )
}